import { render, staticRenderFns } from "./NodeChildren.vue?vue&type=template&id=227729e0&scoped=true"
import script from "./NodeChildren.vue?vue&type=script&lang=js"
export * from "./NodeChildren.vue?vue&type=script&lang=js"
import style0 from "./NodeChildren.vue?vue&type=style&index=0&id=227729e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227729e0",
  null
  
)

export default component.exports